<!--Main Body-->
<div class="container p-0 marketplace-attribute" *ngIf="localisedAttributes">
  <div class="form-floating form-attribute" *ifScreenSize="ScreenType.Desktop">
    <select
      class="form-select"
      [ngClass]="{ 'init-padding': !selectedAttributeValue }"
      id="attrSelect"
      (change)="onAttributeChange($event.target.value)"
    >
      <option selected disabled class="default-option">
        {{ 'marketplace.attribute.button' | translate }}
        <span *ngFor="let attr of localisedAttributes; index as idx"
          >{{ idx % 2 == 1 ? ' - ' : '' }}{{ attr?.DisplayName }}
        </span>
      </option>
      <option
        class="attribute-option"
        *ngFor="let attrMapping of marketplaceItem.AttributeMappings"
        [disabled]="attrMapping?.AvailableStockCount == 0"
        fgbclAttributeTransValue
        [attributeList]="localisedAttributes"
        [attributeDataOrId]="attrMapping"
        [value]="attrMapping.AttributeMappingId"
      ></option>
    </select>
    <label class="form-attribute-label" *ngIf="selectedAttributeValue" for="attrSelect">
      <ng-container *ngTemplateOutlet="selectAttributeText"></ng-container>
    </label>
  </div>

  <button
    *ifScreenSize="ScreenType.Mobile"
    class="btn btn-select-attribute"
    type="button"
    data-bs-toggle="offcanvas"
    data-bs-target="#offcanvasAttribute"
    aria-controls="offcanvasAttribute"
    (click)="addStyleBackdrop()"
  >
    <div *ngIf="!selectedAttributeValue">
      <ng-container *ngTemplateOutlet="selectAttributeText"></ng-container>
      <!-- <span *ngFor="let attr of localisedAttributes; index as idx">{{ idx % 2 == 1 ? ' & ' : '' }}{{ attr?.DisplayName }} </span> -->
    </div>
    <div *ngIf="selectedAttributeValue" class="mobile-select-attribute">
      <label class="selected-label">
        <ng-container *ngTemplateOutlet="selectAttributeText"></ng-container>
      </label>
      <span fgbclAttributeTransValue [attributeList]="localisedAttributes" [attributeDataOrId]="selectedAttributeValue"></span>
    </div>
    <div class="material-icons">arrow_forward_ios</div>
  </button>

  <div
    class="offcanvas offcanvas-attribute offcanvas-bottom"
    tabindex="-1"
    id="offcanvasAttribute"
    aria-labelledby="offcanvasAttributeLabel"
  >
    <div class="offcanvas-header">
      <div class="offcanvas-attributes-title fw-bold" id="offcanvasAttributeLabel">
        <ng-container *ngTemplateOutlet="selectAttributeText"></ng-container>
      </div>
      <button type="button" class="btn-close material-icons" data-bs-dismiss="offcanvas">close</button>
    </div>
    <div class="offcanvas-body">
      <button
        class="offcanvas-attribute-btn"
        *ngFor="let attrMapping of marketplaceItem.AttributeMappings"
        [disabled]="attrMapping?.AvailableStockCount == 0"
        (click)="onAttributeChange(attrMapping.AttributeMappingId)"
        [ngClass]="{
          'offcanvas-attribute-btn-disabled': attrMapping?.AvailableStockCount == 0,
          'offcanvas-attribute-btn-active': attrMapping?.AttributeMappingId == selectedAttributeValue?.AttributeMappingId,
        }"
        data-bs-dismiss="offcanvas"
        fgbclAttributeTransValue
        [attributeList]="localisedAttributes"
        [attributeDataOrId]="attrMapping"
      ></button>
    </div>
  </div>
  <ng-template #selectAttributeText>
    {{ 'marketplace.attribute.button' | translate }}
    <span *ngFor="let attr of localisedAttributes; index as idx">{{ idx % 2 == 1 ? ' & ' : '' }}{{ attr?.DisplayName }} </span>
  </ng-template>
</div>
